<template>
    <div class="edit-folder">
        <input type="text" placeholder="Name" v-model="current_name" class="form-control">
        <button class="btn btn-sm btn-primary" @click="EditName" :disabled="current_name == ''">Save</button>
    </div>
</template>

<script>
    export default {
        name: "EditFolderName",
        props: { folderId: Number, name: String },

        data(){
            return {
                current_name: ''
            }
        },

        mounted(){
            this.current_name = this.name;
        },

        methods: {
            EditName(){
                this.$store.dispatch('editFolder', {
                    folder_id: this.folderId,
                    name: this.current_name
                });

                this.$parent.closeModal();
            }
        },

        watch: {
            name(){
                this.current_name = this.name;
            }
        }
    }
</script>
